import store from '@/store';

export default (to, from, next) => {
    const is_product_type_transfer_allowed = store.getters.is_product_type_transfer_allowed;

    return {
        allow: is_product_type_transfer_allowed,
        redirect: { name: 'not-found' },
    }
};
